import { render, staticRenderFns } from "./ModalSendQuotation.vue?vue&type=template&id=2d6154c1&"
import script from "./ModalSendQuotation.vue?vue&type=script&lang=js&"
export * from "./ModalSendQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports